import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Box, Button } from '@mui/material';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import ResponsiveAppBar from './Components/ResponsiveAppBar';
import Home from './Pages/Home';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Uses from './Pages/Uses';
import Projects from './Pages/Projects';
import GetCookie from './Services/GetCookie';
import Data from './Data/.json';
import NotFound from './Pages/NotFound';
import About from './Pages/About';
import Services from './Pages/Services';
import Contact from './Pages/Contact';
import Career from './Pages/Articles';
import { BrowserUpdated, CarRentalRounded, Code, ContactMail, ContactsRounded, HomeMax, HomeOutlined } from '@mui/icons-material';
import CookieConsent from './Components/CookieConsent';
import TitrePage from './Pages/TitrePage';
import Carriere from './Pages/Carriere';
import Articles from './Pages/Articles';
import { useTranslation } from 'react-i18next';
import FocusIA from './Pages/FocusIA';
import { Analytics } from "@vercel/analytics/react"
import imageIa from './Files/ia.png'

function App() {

  localStorage.setItem("mode", "light")
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLDivElement>, link: string) => {
    navigate(link)
    const anchor =
      (
        (event.target as HTMLDivElement).ownerDocument || document
      ).querySelector(link.includes("#") ? ("#" + link.split("#")[1]) : "#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  };
  return (
    <>
      <div draggable={false} className="App" style={{ backgroundColor: GetCookie(Data.mode) == 'light' ? "white" : GetCookie(Data.mode) == 'dark' ? '#000135' : "", color: GetCookie(Data.mode) == 'light' ? "#101316" : GetCookie(Data.mode) == 'dark' ? 'rgba(255, 255, 255, 1)' : "" }}>
        <CookieConsent />
        <Box sx={{ display: { xs: 'none', md: 'block' } }} className="raccourci">
          <Button title={t("accueil")} size='small' style={{ padding: "15px", backgroundColor: "rgba(22, 79, 125, 0)", borderRadius: "0px", color: "rgb(255, 255, 255)" }} onClick={(e: any) => { (handleClick(e, "/")) }}><HomeOutlined style={{ fontSize: "20px" }} /></Button><br />
          <Button title={t("contact")} size='small' style={{ padding: "15px", backgroundColor: "rgba(22, 79, 125, 0)", borderRadius: "0px", color: "rgb(255, 255, 255)" }} onClick={(e: any) => { (handleClick(e, "/contact")) }}><ContactsRounded style={{ fontSize: "20px" }} /></Button><br />
          <Button title={t("services")} size='small' style={{ padding: "15px", backgroundColor: "rgba(22, 79, 125, 0)", borderRadius: "0px", color: "rgb(255, 255, 255)" }} onClick={(e: any) => { (handleClick(e, "/#services")) }}><BrowserUpdated style={{ fontSize: "20px" }} /></Button><br />
          <Button title={t("produit")} size='small' style={{ padding: "15px", backgroundColor: "rgba(22, 79, 125, 0)", borderRadius: "0px", color: "rgb(255, 255, 255)" }} onClick={(e: any) => { (handleClick(e, "/#products")) }}><Code style={{ fontSize: "20px" }} /></Button><br />
          <Button title={t("titrePage.FocusIA.titre")} size='small' style={{ padding: "15px", backgroundColor: "rgba(22, 79, 125, 0)", borderRadius: "0px", color: "rgb(255, 255, 255)" }} onClick={(e: any) => { (handleClick(e, "/focusia/chat")) }}> <img src={imageIa} width={25} style={{borderRadius: "5px"}} /> </Button>
        </Box>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/uses' element={<Uses />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/services' element={<Services />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/career' element={<Carriere />} />
          <Route path='/articles' element={<Articles />} />
          <Route path='/articles/*' element={<Articles />} />
          <Route path='/focusia/chat' element={<FocusIA />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      <Analytics />
    </>
  );
}

export default App;
